const SkillsData = [
  {
    id: "16",
    name: "ANGULAR",
    image: require("../assets/Images/angular.png")
  },
  {
    id: "6",
    name: "ASP.NET",
    image: require("../assets/Images/dot-net.png")
  },
  {
    id: "5",
    name: "C#",
    image: require("../assets/Images/csharp.png"),
  },
  {
    id: "11",
    name: "Git",
    image: require("../assets/Images/git.png"),
  },
  {
    id: "12",
    name: "GitHub",
    image: require("../assets/Images/github.png"),
  },
  {
    id: "1",
    name: "HTML",
    image: require("../assets/Images/html.png"),
  },
  {
    id: "2",
    name: "CSS",
    image: require("../assets/Images/css.png"),
  },
  {
    id: "3",
    name: "JavaScript",
    image: require("../assets/Images/javascript.png"),
  },
  {
    id: "4",
    name: "Jquery",
    image: require("../assets/Images/jquery.png"),
  },
  {
    id: "7",
    name: "Visual Studio",
    image: require("../assets/Images/vs.png"),
  },
  {
    id: "8",
    name: "VS Code",
    image: require("../assets/Images/vscode.png"),
  },
  {
    id: "9",
    name: "MySQL",
    image: require("../assets/Images/mysql.png"),
  },
  {
    id: "10",
    name: "SQL Server",
    image: require("../assets/Images/sqlserver.png"),
  },

  {
    id: "13",
    name: "Java",
    image: require("../assets/Images/java.png")
  },
  {
    id: "14",
    name: "Python",
    image: require("../assets/Images/python.png")
  },
  {
    id: "15",
    name: "Android Studio",
    image: require("../assets/Images/android.png")
  },

];

export default SkillsData;
